<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">Delete Support Module</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <p class="text-body-1">
            Are you sure you want to delete this support module? This will
            deactivate the module.
          </p>
          <p v-if="module" class="text-body-2 mt-2 font-weight-medium">
            Module: {{ module.module_name }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">Cancel</v-btn>
          <v-btn
            color="error"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_support_module_masters } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "DeleteModule",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: Boolean,
    module: Object,
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      this.loading = true;

      try {
        const input = {
          module_id: this.module?.module_id || this.module?.id || "",
          module_status: "DEACTIVE",
        };

        const response = await client.graphql({
          query: edit_support_module_masters,
          variables: {
            input,
          },
        });

        const rawPayload = response.data.edit_support_module_masters;
        const responseData =
          typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;

        if (responseData.status == "SUCCESS" || responseData.success === true) {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Support module deleted successfully",
            color: "success",
          };
          this.$emit("deleted");
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message || "Failed to delete support module",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error deleting support module:", error);
        this.snackbar = {
          show: true,
          message: error.message || "Failed to delete support module",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped></style>
